// Surface for the D&B carousel cards: a radial gradient layered over the primary background.
// Value taken verbatim from the Figma dev panel (the Figma variable names fall back to the
// literal brand blues because those variables are not defined in this app).
export const DNB_CAROUSEL_SURFACE =
  'radial-gradient(87.13% 126.46% at 50% 126.46%, var(--Blue-600, #0E5CF4) 0%, var(--Blue-900, #000A62) 100%), var(--surface-background-primary, #FFF)';
